import Drawer from "@material-ui/core/Drawer";
import HubSettings from "./HubSettings";
import React from "react";

export default function HubSettingsDrawer({hubId, width, open, onClose}) {
    if (!open) {
        return null;
    }

    return (
        <Drawer anchor={"right"} variant={"temporary"} open={open} onBackdropClick={onClose}>
            <HubSettings hubId={hubId} width={width} onClose={onClose}/>
        </Drawer>
    );
}